export default __webpack_public_path__ + "static/setup_split_terminals-ed954ec3a23edb5198af839752d2bf03.png";